// extracted by mini-css-extract-plugin
export var modal = "_hd-0";